// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 1024px)";
var _4 = "voucher-1td6X";
var _5 = "header-2aBVE";
var _6 = "info-3heNF";
var _7 = "title-1Zo6h";
var _8 = "number-3tAt6";
var _9 = "value-3JFgb";
var _a = "expires-3NBME";
var _b = "expired-Mu94Q";
export { _1 as "__esModule", _2 as "mobile", _3 as "tablet", _4 as "voucher", _5 as "header", _6 as "info", _7 as "title", _8 as "number", _9 as "value", _a as "expires", _b as "expired" }
export default { "__esModule": _1, "mobile": _2, "tablet": _3, "voucher": _4, "header": _5, "info": _6, "title": _7, "number": _8, "value": _9, "expires": _a, "expired": _b }
